import { routes } from "src/shared/routes";
import { FAQS, TERMS_AND_CONDITION, AnalyticsHeader } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const phoenixsuns_pass: TTeamConfig = {
  TEAM_SCHEMA: "phoenixsuns_pass",
  TEAM_FULL_NAME: "Phoenix Suns",
  BROWSER_TITLE: "Suns Up Ticket Pass",
  CLIENT_ID: "e992dca28572.seasonshare.suns-suns.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#e56020",
    COLORS_SECONDARY: "#1d1160",
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/suns/",
    LOGOUT_ON_INVALID_SESSION: true,
    IS_INTERCOM_ENABLED: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
      HIDE_PASS_DETAILS: true,
    },
    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SHOW_FAQ_BUTTON: true,
    },
    HIDE_UPCOMING_EVENTS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/PHOENIX%20SUNS/PSuns_Primary_Icon.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/PHOENIX%20SUNS/image.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/PHOENIX%20SUNS/desktop-banner.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/PHOENIX%20SUNS/mobile-banner.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/PHOENIX%20SUNS/image.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
